import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
    DynamicDialogConfig,
    DynamicDialogRef,
    SelectItem
} from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';

@Component({
    selector: 'ef-invoice-session-update-dialog',
    templateUrl: './invoice-session-update-dialog.component.html',
    styleUrls: ['./invoice-session-update-dialog.component.scss'],
    standalone: false
})
export class InvoiceSessionUpdateDialogComponent implements OnInit {
    addresses: SelectItem[];
    bulkVoucherFormGroup: UntypedFormGroup;
    constructor(
        public dialogRef: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private log: LoggingService
    ) {
        this.bulkVoucherFormGroup = new UntypedFormGroup({
            Voucheraddrid: new UntypedFormControl(),
            Remitaddrid: new UntypedFormControl(),
            ShowCN: new UntypedFormControl(),
            Feeseparate: new UntypedFormControl(),
            Vouchercontractdesc: new UntypedFormControl()
        });
        this.addresses = config.data.addresses;
    }

    ngOnInit(): void {}
}
